import DentistDetails from './DentistDetails';

export { default as DentistDetailsModal } from './DentistDetailsModal';
export { default as OtherDentistDetailsMobile } from './OtherDentistDetailsMobile';
export { default as PartnerDentistDetailsMobile } from './PartnerDentistDetailsMobile';

export default DentistDetails;
